import {
  ChangeDetectionStrategy,
  Component,
  inject,
  InjectionToken,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  ValueProvider
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DayStatus } from '@core/components/times/times.types';
import { TranslationPipeModule, TranslationService } from "@ogs-gmbh/ngx-translate";
import { TranslationInfo } from "@shared/types/translation-info";
import { Observable } from "rxjs";
import { SlicePipe } from "@shared/pipes/slice.pipe";

export const OPENING_TIMES_TRANSLATION_SCOPE: InjectionToken<string | string[]> = new InjectionToken<string | string[]>("opening-times-translation-scope");
export function provideOpeningTimesTranslationScope (value: string | string[]): ValueProvider {
  return {
    provide: OPENING_TIMES_TRANSLATION_SCOPE,
    useValue: value
  };
}
@Component({
  selector: 'app-opening-times-days',
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    TranslationPipeModule,
    SlicePipe
  ],
  templateUrl: './opening-times-days.component.html',
  styleUrl: './opening-times-days.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OpeningTimesDaysComponent {
  public days: InputSignal<TranslationInfo[]> = input.required<TranslationInfo[]>();

  public dayStatuses: InputSignal<DayStatus[]> = input.required<DayStatus[]>();

  public isDayDisabledFn: InputSignal<(dayIndex: number) => boolean>
    = input.required<(dayIndex: number) => boolean>();

  readonly dayToggle: OutputEmitterRef<number> = output<number>();

  protected translationScope: string | string[] | null = inject(OPENING_TIMES_TRANSLATION_SCOPE, { optional: true });

  protected readonly labelCache: Map<string, Observable<string>> = new Map<string, Observable<string>>();

  private translationService: TranslationService = inject(TranslationService);

  protected onDayClick (dayIndex: number): void {
    if (this.isDayDisabledFn()(dayIndex)) return;

    this.dayToggle.emit(dayIndex);
  }

  getStatusClass (dayIndex: number): string {
    const currentStatus: DayStatus | undefined = this.dayStatuses()[ dayIndex ];

    switch (currentStatus) {
      case 'open': {
        return 'opening-times__day--open';
      }

      case 'closed': {
        return 'opening-times__day--closed';
      }

      default: {
        return 'opening-times__day--neutral';
      }
    }
  }
}
